// extracted by mini-css-extract-plugin
export default {"indicatorIcon":"promoCode_indicatorIcon__onW0R","slide":"promoCode_slide__-M2gO"};